
            const data = {"name":"ic_drop_down","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M7 10l5 5 5-5H7z\" _fill=\"#CCC\"/>","originalColors":[{"type":"fill","color":"#CCC"}],"stopColors":[]}}
        
                module.exports = data
                